module.exports = "https://r.nearpod.com/assets/media/image/ic_live_session-5b502fc059a5b9235a5b2dc044bba3bf.svg";